// extracted by mini-css-extract-plugin
module.exports = {"forgot_password_button":"ForgotPassword_forgot_password_button__RaQfw","link":"ForgotPassword_link__FILrl"};